import moment from "moment";
import { eeaPeriodEnd } from "./eeaTimeLimits";

type NoticePeriodAnchor = {
  publishedAt: string | null | undefined;
  plannedAnnouncement: string | null | undefined;
  now: Date;
};

export const noticePeriodStart = ({ publishedAt, plannedAnnouncement, now }: NoticePeriodAnchor): string => {
  if (publishedAt) return moment(publishedAt).toISOString();
  return (plannedAnnouncement ? moment.max(moment(plannedAnnouncement), moment(now)) : moment(now)).toISOString();
};

export const earliestDeadlineAfterNotice = ({
  minimumDays,
  ...anchor
}: NoticePeriodAnchor & { minimumDays: number }): string =>
  eeaPeriodEnd(noticePeriodStart(anchor), minimumDays).toISOString();

export const earliestTenderDeadline = ({
  minimumDays,
  announcementDate,
  now,
  marginDays = 0,
}: {
  minimumDays: number;
  announcementDate: string | null | undefined;
  now: Date;
  marginDays?: number;
}): string =>
  earliestDeadlineAfterNotice({
    minimumDays: minimumDays + marginDays,
    publishedAt: null,
    plannedAnnouncement: announcementDate,
    now,
  });
